<template>
  <v-card min-width="21vw" align="center" justify="center" light outlined>
    <v-card-title style="background-color: #d2d7e1">
      <v-list-item>
        <v-list-item-title>
          <h3>{{ club.name }}'s Pro Expiration Date</h3>
        </v-list-item-title>
        <v-spacer />
        <v-list-item-action>
          <v-icon class="icon" @click="closeWindow" icon>fa-times</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="pa-5">
      <v-overlay :absolute="true" :value="overlayProcessingProChange"><v-progress-circular :size="50" width="5" indeterminate/></v-overlay>
      <v-form v-model="valid">
        <p> Pro expiration date of <b>{{ club.name }}</b> </p>
        <v-date-picker v-model="proExpirationTimeString" color="green lighten-1"/>
        <div class="mb-3">
          <v-btn class="mr-5" @click="changeProExpirationDate">Change Pro Time</v-btn>
          <v-btn @click="closeWindow">Close</v-btn>
        </div>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import Repository from "../../../repositories/club";

export default {
  name: "EditClub",
  props: {
    club: Object,
  },
  data() {
    return {
      valid: false,

      overlayProcessingProChange: false,

      // Values
      proExpirationTimeString: null,
      proExpirationTime: null,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.proExpirationTime = this.club.proExpirationTime;
      this.proExpirationTimeString = this.proExpirationTime.substr(0, 10);
    },
    changeProExpirationDate() {
      let dateArray = this.proExpirationTimeString.split("-");
      let proTime = {
        clubId: this.club.id,
        newDate: new Date(
          Number.parseInt(dateArray[0]),
          Number.parseInt(dateArray[1]) - 1,
          Number.parseInt(dateArray[2])
        ),
      };

      if(proTime.newDate <= new Date()) {
        alert(`You cannot!\nPro Time for ${this.club.name} can't be set in the past.`);
        return;
      } else {
        this.overlayProcessingProChange = true;
        Repository.changeProExpirationDate(proTime).then((response) => {
          if (response.status < 400) {
            alert(
              `${this.club.name} Pro Time was successfully updated`
            );
            this.closeWindow();
            this.$emit("proDateEdited");
          } else {
            alert(
              `There was an error when trying to update ${this.club.name} Pro Time`
            );
            this.overlayProcessingProChange = false;
          }
        });
      }
    },
    closeWindow() {
      this.$emit("closeWindow");
    },
  },
};
</script>

<style scoped>
</style>
